import styled, { css } from "styled-components"
import { Scroll } from "styles/GlobalCss"

const WrapTestTakerForm = styled.div`
.initial-fields {
display: flex;
column-gap:10px;
width: 100%;
}

._tz {
width: 100%
}

padding:2px;
._child__first_name{
grid-area:child__first_name;
}
._child__last_name{
grid-area:child__last_name;
}
._child__gender{
grid-area:child__gender;
}
._child__tz{
grid-area:child__tz;
}
._child__db{
grid-area:child__db;
}
._child__langauge{
grid-area:child__langauge;
}
._parent__first_name{
grid-area:parent__first_name;
}
._parent__last_name{
grid-area:parent__last_name;
}
._parent__email{
grid-area:parent__email;
}
._parent__phone{
grid-area:parent__phone;
}
._child__school{
grid-area:child__school;
}
._child__grade{
grid-area:child__grade;
}
._child__t_class{
grid-area:child__t_class;
}
`

const TestTakerForm = css`
display: grid;
grid-gap: 12px;
grid-template-columns: min-content;
grid-template-areas:
 "child__tz child__tz child__tz child__db child__db child__db"
 "child__first_name child__first_name child__last_name child__last_name child__gender child__gender"
 "child__school child__school child__school child__school child__school child__school" 
 "child__grade child__grade child__grade child__t_class child__t_class child__t_class"
 "child__langauge child__langauge child__langauge child__langauge child__langauge child__langauge"
 "parent__first_name parent__first_name parent__first_name parent__last_name parent__last_name parent__last_name"
 "parent__phone parent__phone parent__phone parent__email parent__email parent__email"
`

export { TestTakerForm, WrapTestTakerForm }